// ページネーション設定: 表示件数
export const dealPaginatinPerTypes = {
  label: '表示件数',
  options: [
    // { label: '1', value: 1 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ],
};

// ページネーション設定: 並び順（キー）
export const dealPaginatinSortByTypes = {
  label: '並び順（キー）',
  options: [{ label: '登録日', value: 'createdAt' }],
};

// ページネーション設定: 並び順（タイプ）
export const dealPaginatinSortOrderTypes = {
  label: '並び順（タイプ）',
  default: {
    options: [
      { label: '新しい', value: 'DESC' },
      { label: '古い', value: 'ASC' },
    ],
  },
  createdAt: {
    options: [
      { label: '新しい', value: 'DESC' },
      { label: '古い', value: 'ASC' },
    ],
  },
};

// ページネーション設定: 表示件数
export const joinedCompanyDealPaginatinPerTypes = {
  label: '表示件数',
  options: [
    // { label: '1', value: 1 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ],
};

// ページネーション設定: 並び順（キー）
export const joinedCompanyDealPaginatinSortByTypes = {
  label: '並び順（キー）',
  options: [{ label: '登録日', value: 'createdAt' }],
};

export const joinedCompanyDealPaginatinSortOrderTypes = {
  label: '並び順（タイプ）',
  default: {
    options: [
      { label: '降順', value: 'DESC' },
      { label: '昇順', value: 'ASC' },
    ],
  },
  createdAt: {
    options: [
      { label: '新しい', value: 'DESC' },
      { label: '古い', value: 'ASC' },
    ],
  },
};

export const dealSubscribeSurveyTypes = {
  label: 'パートナー活用事例のシェア、インタビュー、などへ協力いただけますか？',
  options: [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
    { label: 'その他', value: 'OTHER' },
  ],
};

export const dealStatuses = {
  label: 'ステータス',
  options: [
    { label: '公開', value: 'ACTIVE' },
    { label: '下書き', value: 'DRAFT' },
    { label: '非公開', value: 'INACTIVE' },
  ],
};
